import axios from 'axios';

const BASE_URL = 'https://horizontclinic.com/horizont-be';

export const isLoggedIn = async () => {
  const token = localStorage.getItem('token');
  try {
    const res = await axios.get(`${BASE_URL}/isLoggedIn.php`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    });
    return res.data?.loggedIn === true ? { loggedIn: true, user: res.data.user } : { loggedIn: false };
  } catch (e) {
    return { loggedIn: false };
  }
};

export const logout = () => {
  localStorage.removeItem('token');
  window.location.href = '/login';
};
